import { ENTRY_INTRO_OFFER_WINDOW_MS } from '@tipi/shared'

export type LeadFormOfferRemaining = {
    hours: number
    minutes: number
    seconds: number
    leftMs: number
    progressRatio: number
    isExpired: boolean
}

const pad2 = (value: number) => String(value).padStart(2, '0')

export const formatOfferCountdownPart = (value: number) => pad2(value)

export const getLeadFormOfferRemaining = (
    offerEndsAt: Date,
    now: Date = new Date(),
    windowMs: number = ENTRY_INTRO_OFFER_WINDOW_MS,
): LeadFormOfferRemaining => {
    const leftMs = Math.max(0, offerEndsAt.getTime() - now.getTime())
    const totalSeconds = Math.floor(leftMs / 1000)
    return {
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
        leftMs,
        progressRatio: Math.max(0, Math.min(1, leftMs / windowMs)),
        isExpired: leftMs <= 0,
    }
}
